import * as React from 'react';
import EditorViewState from '../store/schema/EditorViewState';
import updateContent from '../actions/updateContent';
import { keydownHandler } from 'owa-hotkeys';
import { observer } from 'mobx-react';

export interface PlainTextEditorProps {
    viewState: EditorViewState;
    plainTextPlaceholder: string;
    onFocus?: () => void;
    plainTextEditorRefCallback?: (ref: HTMLTextAreaElement) => void;
    classNames?: string;
}

@observer
export default class PlainTextEditor extends React.Component<PlainTextEditorProps, {}> {
    private textArea: HTMLTextAreaElement;

    render() {
        const { classNames, plainTextPlaceholder, onFocus, viewState } = this.props;

        return (
            <div>
                <textarea
                    ref={this.refCallback}
                    className={classNames}
                    placeholder={plainTextPlaceholder || ''}
                    onFocus={onFocus}
                    onChange={this.onChange}
                    value={viewState.content}
                />
            </div>
        );
    }

    @keydownHandler(
        'ctrl+z',
        true /*stopPropagation*/,
        false /*preventDefault*/,
        true /*allowHotkeyOnTextFields*/
    )
    stopUndoPropagation() {
        // do nothing -- this keydown handler stops propagation so that the mailmodule
        // does not eat the undo action & the browser's native Undo functionality can work.
    }

    focus() {
        if (this.textArea) {
            this.textArea.focus();
        }
    }

    private refCallback = (ref: HTMLTextAreaElement) => {
        this.textArea = ref;

        if (this.props.plainTextEditorRefCallback) {
            this.props.plainTextEditorRefCallback(ref);
        }
    };

    private onChange = () => {
        updateContent(this.props.viewState, this.textArea.value);
    };
}
